<template>
  <div class="customer-doc-list">
    <slot name="headlineDocuments">Deine Dokumente</slot>
    <LoginConfirm ref="doLoginConfirmRef">
      <template #txtInvalidLoginConfirmPassword><slot name="txtInvalidLoginConfirmPassword"></slot></template>
    </LoginConfirm>
    <div class="customer-doc-list-filter" v-if="filterShow">
      <b-form>
        <div class="custom-control custom-switch">
          <input
            @click="filter.active = !filter.active"
            class="custom-control-input"
            type="checkbox" v-model="filter.active" value="1"
            id="switchDocumentFilter"
          >
          <label class="custom-control-label" for="switchDocumentFilter">
            <slot name="lblDocumentFilterSwitch"></slot>
          </label>
        </div>
        <div class="filter-options" v-if="filter.active">
          <b-form-group>
            <b-form-radio-group name="showDocumentType" v-model="filter.type" class="rows">
              <b-form-radio v-if="hasBills" :value="'bills'" id="showDocumentType_bills" v-model="filter.type"><slot name="lblTypeBills"></slot></b-form-radio>
              <b-form-radio v-if="hasDunnings" :value="'dunnings'" id="showDocumentType_dunnings" v-model="filter.type"><slot name="lblTypeDunnings"></slot></b-form-radio>
              <b-form-radio v-if="hasItemisedBills" :value="'evns'" id="showDocumentType_evns" v-model="filter.type"><slot name="lblTypeItemisedBills"></slot></b-form-radio>
            </b-form-radio-group>
          </b-form-group>
        </div>
      </b-form>
    </div>
    <div class="document-list" v-if="this.filteredDocumentList.length > 0">
      <div v-for="doc in this.filteredDocumentList" :key="doc.identifier" class="document-entry" @click="triggerDocumentDownload(doc)">
        <div class="name"><a :href="'javascript:;'" @click.prevent="">{{documentName(doc, false)}}</a></div>
        <div class="date">{{dateFormatter(doc.date)}}</div>
      </div>
    </div>
    <div v-else>
      <div class="no-documents">
        <slot name="txtNoDocuments"></slot>
      </div>
    </div>
  <div v-if="showError" v-html="this.errorMsg" class="error-box"></div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import { wrapQuery } from '@/helper/wrapGQLQuery'
import { validationMixin } from 'vuelidate'
import transaction from '@/mixins/transaction'
import LoginConfirm from '@/components/process/generic/Login/LoginConfirm.vue'
import doLoginConfirm from '@/mixins/doLoginConfirm'
import { splitError } from '@/helper/splitError'

import logout from '@/mixins/logout'
import dateFormatter from '@/mixins/formatters/dateFormatter'
import axios from 'axios'
import FileSaver from 'file-saver'
import appFileSaver from '@/mixins/appFileSaver'
import { mapGetters } from 'vuex'

const typeBills = 'bills'
const typeDunnings = 'dunnings'
const typeItemisedBills = 'evns'

const AvailableDocTypes = ['bills', 'evns', 'dunnings']

const initialDocumentState = {
  evns: [],
  bills: [],
  dunnings: []
}

export default {
  name: 'CustomerDocumentList',
  data () {
    return {
      loggingOut: false,
      filterDocumentType: AvailableDocTypes,
      customerDocuments: initialDocumentState,
      emptyFilter: {
        documentType: null
      },
      filter: {
        active: false,
        type: null
      },
      showError: false,
      errorMsg: {
      }
    }
  },
  mounted () {
    this.startLoader()
    this.resetLoginConfirm()
  },
  props: {
    logoutRedirectTo: {
      type: String,
      default: null
    }
  },
  components: {
    LoginConfirm
  },
  mixins: [
    validationMixin,
    dateFormatter,
    transaction('consumerDocumentList'),
    doLoginConfirm('doLoginConfirmRef'),

    logout,
    appFileSaver
  ],
  methods: {
    documentName (doc, withDate = false) {
      let docName = doc.identifier

      if (this.filterApply) {
        doc.type = this.filter.type
      }

      if (doc.type === typeItemisedBills) {
        docName = this.getSlotText('txtEVNDocuments')
      }
      if (doc.type === typeBills) {
        docName = this.getSlotText('txtBillDocuments')
      }
      if (doc.type === typeDunnings) {
        docName = this.getSlotText('txtDunningDocuments')
      }

      if (withDate) {
        docName = docName + ' vom ' + this.dateFormatter(doc.date)
      }

      return docName
    },
    refreshQuery () {
      this.$apollo.queries.customerDocuments.refetch({
        filter: this.emptyFilter
      })
    },
    triggerDocumentDownload (doc) {
      const filename = this.documentName(doc, true) + '.pdf'
      this.doLoginConfirm().then(() => {
        this.downloadDocument(doc.url, filename)
      }).catch((e) => {
      })
      return false
    },
    downloadDocument (url, filename = 'file.pdf') {
      const me = this

      axios.get(url, {
        baseURL: this.$config.apiUrl || '',
        headers: {
          Authorization: `Bearer ${this.accessToken}`,
          Accept: 'application/pdf'
        },
        responseType: 'blob'
      }).then((response) => {
        const file = new Blob([response.data], { type: response.headers['content-type'] })
        if (this.appTriggerSaveAsFileAvailable()) {
          this.appTriggerSaveAsFile(filename, file)
        } else {
          FileSaver.saveAs(file, filename)
        }
      }).catch((reason) => {
        console.error('downloadDocument', 'error', reason)
        me.$store.commit('addError', 'Fehler beim Abrufen der Datei. (' + reason.response.status + ')')
      })
    },
    doLogout () {
      this.loggingOut = true
      if (this.inWebView) {
        if (this.isIosDevice) {
          window.webkit.messageHandlers.reset.postMessage('logging out')
        } else {
          window.App.reset('logging out')
        }
      }
      this.logOut(this.logoutRedirectTo)
    }
  },
  computed: {
    ...mapGetters([
      'accessToken'
    ]),
    hasItemisedBills () {
      return (typeof this.customerDocuments.evns !== 'undefined' && this.customerDocuments.evns.length > 0)
    },
    hasBills () {
      return (typeof this.customerDocuments.bills !== 'undefined' && this.customerDocuments.bills.length > 0)
    },
    hasDunnings () {
      return (typeof this.customerDocuments.dunnings !== 'undefined' && this.customerDocuments.dunnings.length > 0)
    },
    filterShow () {
      let docTypes = 0
      if (this.hasItemisedBills) docTypes++
      if (this.hasBills) docTypes++
      if (this.hasDunnings) docTypes++
      return (docTypes > 1)
    },
    filterGetDefaultType () {
      if (this.hasBills) return typeBills
      if (this.hasDunnings) return typeDunnings
      if (this.hasItemisedBills) return typeItemisedBills
      return null
    },
    filterApply () {
      return this.filterShow && this.filter.active
    },
    filteredDocumentList () {
      if (this.filterApply) {
        if (this.filter.type === typeBills && this.hasBills) {
          return this.customerDocuments.bills
        }
        if (this.filter.type === typeDunnings && this.hasDunnings) {
          return this.customerDocuments.dunnings
        }
        if (this.filter.type === typeItemisedBills && this.hasItemisedBills) {
          return this.customerDocuments.evns
        }
      } else {
        return this.getDocumentList
      }
      return []
    },
    getDocumentList () {
      // create array with all documents
      const docList = []

      if (typeof this.customerDocuments.evns !== 'undefined' && this.customerDocuments.evns.length > 0) {
        for (let i = 0; i < this.customerDocuments.evns.length; i++) {
          const doc = this.customerDocuments.evns[i]
          doc.type = typeItemisedBills
          docList.push(doc)
        }
      }
      if (typeof this.customerDocuments.bills !== 'undefined' && this.customerDocuments.bills.length > 0) {
        for (let i = 0; i < this.customerDocuments.bills.length; i++) {
          const doc = this.customerDocuments.bills[i]
          doc.type = typeBills
          docList.push(doc)
        }
      }
      if (typeof this.customerDocuments.dunnings !== 'undefined' && this.customerDocuments.dunnings.length > 0) {
        for (let i = 0; i < this.customerDocuments.dunnings.length; i++) {
          const doc = this.customerDocuments.dunnings[i]
          doc.type = typeDunnings
          docList.push(doc)
        }
      }

      function compare (a, b) {
        const da = a.date
        const db = b.date
        if (da > db) {
          return -1
        }
        if (da < db) {
          return 1
        }
        return 0
      }

      return docList.sort(compare)
    }
  },
  apollo: {
    consumerDocumentList: function () {
      return wrapQuery(
        gql`query consumerDocumentList ($filter: CustomerDocumentFilterInput!) {
          customerDocuments(customerDocumentFilter: $filter) {
            evns { date identifier url }
            bills { date identifier url }
            dunnings { date identifier url }
          }
        }`, this, 'customerDocuments', {
          filter: this.emptyFilter
        }, () => {
          if (this.filter.type === null) {
            this.filter.type = this.filterGetDefaultType
          }
          this.showError = false
          this.stopLoader()
        },
        {},
        (error) => {
          splitError(error).forEach(e => {
            this.errorMsg = e.message
          })
          if (!this.showError) {
            const data = {
              type: 'technical',
              message: this.errorMsg
            }
            if (typeof window.trackingNS?.track?.tracking === 'function') {
              window.trackingNS.track.tracking('error', data)
            }
          }
          this.showError = true
          this.stopLoader()
        }
      )
    }
  }
}
</script>
